import { render, staticRenderFns } from "./campaign-email-template-settings.vue?vue&type=template&id=14299f73&"
import script from "./campaign-email-template-settings.vue?vue&type=script&setup=true&lang=js&"
export * from "./campaign-email-template-settings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports